// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1IEoK","overflowing":"ReadFullNote_overflowing__GLlRA"};